import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GridColumn } from "../../../../modules/preferences/models/preferences.model";

@Component({
  selector: 'app-column-order-dialog',
  templateUrl: './column-order-dialog.component.html',
  styleUrls: ['./column-order-dialog.component.scss']
})
export class ColumnOrderDialogComponent {

  @Output() orderChanged = new EventEmitter<GridColumn[]>();
  columns: GridColumn[] = [];

  constructor(
    public dialogRef: MatDialogRef<ColumnOrderDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {

    this.columns = [...this.data.columns];

    this.columns.sort((a, b) => a.DisplayOrder - b.DisplayOrder);

  }

  close(): void {

    this.dialogRef.close(this.columns);

  }

  moveUp(index: number): void {

    if (index === 0) {
      return;
    }

    const temp = this.columns[index];

    this.columns[index] = this.columns[index - 1];

    this.columns[index - 1] = temp;

    this.updateDisplayOrder();

  }

  moveDown(index: number): void {

    if (index === this.columns.length - 1) {
      return;
    }

    const temp = this.columns[index];

    this.columns[index] = this.columns[index + 1];

    this.columns[index + 1] = temp;

    this.updateDisplayOrder();

  }

  private updateDisplayOrder(): void {

    this.columns.forEach((x, index) => {

      x.DisplayOrder = index + 1;

    });

    this.orderChanged.emit([...this.columns]);

  }

}